import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import App from "./App";

const WEBSITE_URL = "https://byondcare.com.my";
const OG_IMAGE = `${WEBSITE_URL}/logo512.png`;

const routeMeta = [
  {
    path: "/",
    title: "byond care — The only clinic platform with a built-in patient experience",
    description:
      "From queue to consultation to follow-up, byond care connects your clinic with your patients through their own personal health app.",
  },
];

function SeoPage({ path, title, description }) {
  useEffect(() => {
    const canonicalUrl = `${WEBSITE_URL}${path}`;
    document.title = title;

    const upsertMeta = (selector, attribute, key, value) => {
      let tag = document.head.querySelector(selector);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attribute, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", value);
    };

    upsertMeta('meta[name="description"]', "name", "description", description);
    upsertMeta('meta[property="og:title"]', "property", "og:title", title);
    upsertMeta('meta[property="og:description"]', "property", "og:description", description);
    upsertMeta('meta[property="og:url"]', "property", "og:url", canonicalUrl);
    upsertMeta('meta[property="og:image"]', "property", "og:image", OG_IMAGE);
    upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", OG_IMAGE);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);
  }, [description, path, title]);

  return <App />;
}

export default function SeoRoutes() {
  return (
    <Routes>
      {routeMeta.map((item) => (
        <Route
          key={item.path}
          path={item.path}
          element={
            <SeoPage
              path={item.path}
              title={item.title}
              description={item.description}
            />
          }
        />
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
